var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPoshmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-687.000000, -220.000000) translate(662.000000, 196.000000) translate(25.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#602D35",
    fillRule: "nonzero",
    d: "M34.896 14.002c-4.97 0-8.98 4.113-8.98 9.14v14.382h3.322V23.142c0-3.199 2.545-5.758 5.658-5.758 3.144 0 5.659 2.59 5.659 5.758 0 3.047-2.336 5.576-5.33 5.759v3.382c4.97-.122 8.892-4.296 8.772-9.354-.09-4.997-4.16-9.019-9.1-8.927zm-4.25 22.851c0 3.2-2.545 5.759-5.659 5.759-3.143 0-5.658-2.59-5.658-5.759 0-3.047 2.335-5.576 5.329-5.758v-3.382c-4.97.182-8.832 4.418-8.652 9.475.18 5.058 4.34 8.989 9.31 8.806 4.82-.183 8.652-4.235 8.652-9.14V22.471h-3.323v14.381z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPoshmark);
export default __webpack_public_path__ + "static/media/logo-poshmark.a77006f89ba07fe69b20b0585bef8022.svg";
export { ForwardRef as ReactComponent };